import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, HostListener, DoCheck } from "@angular/core";
import { ApiService } from "@app/gateway/services/api.service";
import { UserProfileService } from "@app/gateway/user-profile/user-profile.service";
import { ModalService } from "@app/services/modal/modal.service";
import { TranslateService } from '@ngx-translate/core';
import { HttpHeaders } from '@angular/common/http';
import { ServiceConfigService } from "@app/services/service-config.service";
import { TokenService } from "@app/services/token/token.service";
import { Router } from "@angular/router";
@Component({
    selector: "nh-doc-upload",
    templateUrl: "./document-upload.component.html",
    styleUrls: ["./document-upload.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DocumentUploadComponent implements OnInit, DoCheck {
  @Input() row;
  @Input() selectData;
  @Input() ridpFlow = false;
  @Output() docUploadSuccess = new EventEmitter<any>();
  rows;
  rowsData = [];
  columnData = [{name : "Name", prop : "fullName"},
    {name : "Proof Type", prop : "verfDesc"}
  ]
  uploadDocumentFlag = false;
  verificationForFlag = false;
  data = [];
  documents = [{ docType: null, show: true, file: null, error: false, pageId: null, groupId: null }];
  docType = null;
  referenceData;
  options;
  code;
  tableCode = [];
  error = true;
  showAnother = false;
  screenHeight: number;
  screenWidth: number;
  isMobileView = false;
  mobileWidth = 480;
  userId;
  columns;
  showCZPRmessage = false;
  displayLoading = false;
  docName: string;
  defaultLanguage;
  translatedLang;
  fromMyAppeals;
  vfdProofType;
  isMedicalAppeal: boolean = false;
  continueClick = false;
  successDocUpload = false;
  currentDocType;
  currentDocTypeObj;
  changeType = false;
  currentI;
  filteredDocs = [];
  diffDocTypes = [{ docType: null, show: true, file: null, error: false , commonItems: [], groupId: null }];
  showClose = false;
  currentDocCode;
  displayUpload = true
  isKatieDocUpload : boolean = false;
  partnerOrgDocSwitch: boolean = false;
  showSupportingDocUpload = false;
  supportingDocOptions: any[] = [];
  supportingDocuments: any[] = [{ docType: null, show: true, file: null, error: false, pageId: null, groupId: 2 }];
  supportingDocError = true;
  isSupportingDocFlow = false;
  currentSupportingDocIndex = 0;
  supportingDisplayLoading = false;
  supportingDocName: string;
  constructor(
    private apiService: ApiService,
    private userProfileService: UserProfileService,
    private modalService: ModalService,
    public translateService: TranslateService,
    private serverConfig: ServiceConfigService,
    private token: TokenService,
    private router: Router,
  ) {
    this.getScreenSize();
  }

  @HostListener("window:resize")
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  ngDoCheck() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
  }

  get showAddressWarning(): boolean {
    return this.ridpFlow && this.documents[0]?.docType?.code !== 'WA' && this.documents[0]?.docType?.code !== 'MD' && this.documents.some(doc => doc.file !== null);
  }

  openSupportingDocUpload(): void {
    this.showSupportingDocUpload = true;
    if (!this.supportingDocOptions.length) {
      const url = `publ/reference-tables/retrieve?table=RIDPSUPPORTINGDOCINFO`;
     this.supportingDocuments = [{ docType: null, show: true, file: null, error: false, pageId: 1, groupId: 2 }];
      this.apiService.get(url, null, { headers: new HttpHeaders({ 'pageId': 'RIDPUD', 'sessionId': this.token.getSessionId() }) }).subscribe((res:any) => {
        this.supportingDocOptions = res?.['columnDetails'] || [];
      });
    }
  }

  cancelSupportingDocUpload(): void {
    this.showSupportingDocUpload = false;
    this.supportingDocuments = [{ docType: null, show: true, file: null, error: false, pageId: 1, groupId: 2 }];
    this.supportingDocError = true;
  }

  selectedSupportingOption(): void {
    this.supportingDocuments.forEach(s => { if (!s.file) s.show = true; });
    this.updateSupportingDocError();
  }

  getSupportingFileDetails(fileData: any, i: number): void {
    if (fileData.res !== null) {
      this.supportingDocuments[i].show = false;
      this.supportingDocuments[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      this.updateSupportingDocError();
    }
  }

  getSupportingFileDetailsMobile(fileData: any, i: number): void {
    if (fileData.res !== null) {
      this.supportingDocuments[i].show = false;
      this.supportingDocuments[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      this.supportingDocuments[i]['filePreview'] = fileData.fileRes.file?.rawFile?.filePreview;
      this.updateSupportingDocError();
      this.isSupportingDocFlow = true;
      this.filteredDocs = this.supportingDocuments.filter(s => s.file !== null);
      this.currentDocType = this.translatedLang !== 'en'
        ? this.supportingDocuments[i].docType?.spDescription
        : this.supportingDocuments[i].docType?.enDescription;
      this.changeType = false;
      this.successDocUpload = true;
      this.showClose = false;
      this.scrollToTop();
    }
  }

  addSupportingPage(): void {
    this.supportingDocuments.push({
      docType: this.supportingDocuments[0].docType,
      show: true,
      file: null,
      error: false,
      pageId: this.supportingDocuments.length + 1,
      groupId: 2
    });
    this.updateSupportingDocError();
  }

  removeSupportingItem(i: number): void {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.supportingDocuments[i].file = null;
        this.supportingDocuments[i].show = true;
        this.updateSupportingDocError();
        const hasRemainingFiles = this.supportingDocuments?.some(s => s.file !== null);
        if (!hasRemainingFiles) {
          this.cancelSupportingDocUpload();
        }
      }
    });
  }

  removeSupportingItemMobile(i: number, source: 'filtered' | 'supporting' = 'filtered'): void {
    const headers = new HttpHeaders({
      action: 'delete',
      'pageId': 'TCMUD',
      'sessionId': this.token.getSessionId()
    });

    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        const targetItem = source === 'supporting' ? this.supportingDocuments[i] : this.filteredDocs[i];
        const docId = targetItem?.file?.res;

        if (docId) {
          const removeUrl = `indi/neededDocuments/document/${docId}`;
          this.apiService.post(removeUrl, null, { headers }).subscribe(() => {});
        }

        // Null the item directly by reference — avoids findIndex issues with shared refs
        if (targetItem) {
          targetItem.file = null;
          targetItem.show = true;
        }

        // Also ensure the matching entry in supportingDocuments is nulled (in case filteredDocs is a separate ref)
        const supportingIndex = this.supportingDocuments.findIndex(s => s === targetItem);
        if (supportingIndex >= 0) {
          this.supportingDocuments[supportingIndex].file = null;
          this.supportingDocuments[supportingIndex].show = true;
        }

        this.filteredDocs = this.supportingDocuments.filter(s => s.file !== null);
        this.showClose = false;
        this.updateSupportingDocError();

        if (this.filteredDocs.length === 0) {
          this.successDocUpload = false;
          this.isSupportingDocFlow = false;
          this.cancelSupportingDocUpload();
        }
      }
    });
  }

  removeAllSupportingItemsMobile(): void {
    const headers = new HttpHeaders({
      action: 'delete',
      'pageId': 'TCMUD',
      'sessionId': this.token.getSessionId()
    });

    this.modalService.confirmDeleteMobile().subscribe((res) => {
      if (res) {
        const uploadedDocs = this.supportingDocuments.filter(s => s.file?.res);
        uploadedDocs.forEach(doc => {
          const removeUrl = `indi/neededDocuments/document/${doc.file.res}`;
          this.apiService.post(removeUrl, null, { headers }).subscribe(() => {});
          doc.file = null;
          doc.show = true;
        });
        this.filteredDocs = [];
        this.cancelSupportingDocUpload();
        this.isSupportingDocFlow = false;
      }
    });
  }

  closeSupportingDoc(i: number): void {
    this.supportingDocuments.splice(i, 1);
    this.updateSupportingDocError();
  }

  viewSupportingPdf(i: number, source?: string): void {
    const docId = source === 'mobileBrowser' ? this.filteredDocs[i].file.res.replace(/[{}]/g, '') : this.supportingDocuments[i].file.res.replace(/[{}]/g, '');
    this.userProfileService.getPrintDoc(docId, 'TCMUD').subscribe((res: any) => {
      const file = new Blob([res], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    });
  }

  onEditSupportingDoc(i: number, source: 'filtered' | 'supporting' = 'supporting'): void {
    const selectedDoc = source === 'supporting' ? this.supportingDocuments[i] : this.filteredDocs[i];
    if (!selectedDoc?.file) {
      return;
    }

    this.isSupportingDocFlow = true;
    this.successDocUpload = true;
    this.filteredDocs = this.supportingDocuments.filter(s => s.file !== null);
    this.currentDocType = this.translatedLang !== 'en'
      ? selectedDoc.docType?.spDescription
      : selectedDoc.docType?.enDescription;
    this.changeType = false;
    this.showClose = false;
    this.scrollToTop();
  }


  updateSupportingDocError(): void {
    this.supportingDocError = this.supportingDocuments.some(s => s.file == null || !s.docType);
  }

  get uploadedSupportingCount(): number {
    return this.supportingDocuments.filter(s => s.file !== null).length;
  }

  ngOnInit() {
    this.rows = [...[this.row]];
    this.userProfileService?.fromMyAppeals.subscribe((bool) => {
      this.fromMyAppeals = bool;
    })
    this.partnerOrgDocSwitch = this.serverConfig.getServerConfig().PP_ORG_DOC_SW;
    sessionStorage.removeItem('submitSuccess');
    this.fromMyAppeals = JSON.parse(sessionStorage.getItem('myAppealsUploadProof'));
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.rowsData = [];
      this.options = [];
      if(this.translatedLang !== 'sp'){
        this.columnData = [{name : "Name", prop : "fullName"},
          {name : "Proof Type", prop : "verfDesc"}
        ]
      }else{
        this.columnData = [
          { name: "Nombre", prop: "fullName" },
          { name: "Tipo de comprobante", prop: "verfDesc" },
        ];
      }

      if( this.rows[0]?.['verfDesc'] === 'Documents for Appeals' || this.rows[0]?.['verfDesc'] === 'Documentos para Apelaciones'){
        if (this.translatedLang === 'en') {
          this.rows[0]['verfDesc'] = "Documents for Appeals";
        } else {
          this.rows[0]['verfDesc'] = "Documentos para Apelaciones"
        }
      }

      if (this.rows[0]?.['verfDesc'] === 'Appeal Facts Documents' || this.rows[0]?.['verfDesc'] === 'Documento de información para la apelación') {
        if (this.translatedLang === 'en') {
          this.rows[0]['verfDesc'] = "Appeal Facts Documents";
        } else {
          this.rows[0]['verfDesc'] = "Documento de información para la apelación"
        }
      }

      if (this.rows[0]?.['verfDesc'] === "Additional Information Form" || this.rows[0]?.['verfDesc'] === "Formulario para Información Adicional") {
        if (this.translatedLang === 'en') {
          this.rows[0]['verfDesc'] = "Additional Information Form";
        } else {
          this.rows[0]['verfDesc'] = "Formulario para Información Adicional"
        }
      }

      if(this.rows[0]?.['verfDesc'] === 'Proof Of Assisting Person'){
        if (this.translatedLang === 'en') {
          this.rows[0]['verfDesc'] = "Proof of Assisting Person";
        } else {
          this.rows[0]['verfDesc'] = "Comprobante de persona asistente."
        }
      }
      if(this.rows[0] && this.rows[0]?.['proofRequired'] !== 'N/A'){
        this.verificationForFlag = true;
      }
      if (this.rows[0]) {
        if (this.translatedLang !== 'en') {
          this.rows[0].proofRequiredValue = this.userProfileService.findSpTransalation(this.rows[0].proofRequired);
        } else {
          this.rows[0].proofRequiredValue = this.rows[0]?.proofRequired;
        }
      }

      if (this.currentDocType) {
        this.currentDocType = this.translatedLang !== 'en' ? this.currentDocTypeObj?.['spDescription'] : this.currentDocTypeObj?.['enDescription']
      }
      this.getColumns();   
      if (this.ridpFlow) {
        let url = `publ/reference-tables/retrieve?table=RIDPDOCINFO`;
        this.apiService.get(url, null, { headers: new HttpHeaders({ 'pageId': 'RIDPUD', 'sessionId': this.token.getSessionId() }) }).subscribe((res) => {
          this.options = res?.['columnDetails'] || [];
        });
      }   
    });  
    this.getColumns();  
    if(this.ridpFlow){
      sessionStorage.setItem('ridpDocUpload','true');
        this.documents = [{ docType: null, show: true, file: null, error: false, pageId: 1, groupId: 1 }];
                let url = `publ/reference-tables/retrieve?table=RIDPDOCINFO`;
            this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'RIDPUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
                this.options = res?.['columnDetails'] || [];
            });
    }
  }

  getColumns(){ 
    // if (this.row?.refId && this.row?.isKatie) {
    //   this.isKatieDocUpload = this.row?.isKatie;
    //   this.columns = [
    //     { name: "Name", prop: "fullName" },
    //     { name: "Ref Id", prop: "refId" },
    //     { name: "Proof Type", prop: "verfDesc" },
    //   ];
    //   const url = `publ/reference-tables/retrieve?table=KBDOCUMENTTYPE`;
    //   this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD'})}).subscribe((res) => {
    //     this.options = [...res['columnDetails']];
    //     if (this.translatedLang === 'en') {
    //       this.vfdProofType = "Katie Beckett Supporting Document";
    //     } else {
    //       this.vfdProofType = "Documento de apoyo de Katie Beckett"
    //     }
    //   });
    // }else { 
      if(this.translatedLang !== 'sp'){
        this.columns = [
          { name: "Name", prop: "fullName" },
          { name: "Proof Type", prop: "proofType" },
          { name: "Verification For", prop: "proofRequiredValue" },
          { name: "Due Date", prop: "verfDue" },
        ];
      }else{
        this.columns = [
          { name: "Name", prop: "fullName" },
          { name: "Proof Type", prop: "proofTypeEs" },
          { name: "Verification For", prop: "proofRequiredValue" },
          { name: "Due Date", prop: "verfDue" },
        ];
      }
      if(this.row?.verfDesc === "Documents for Appeals" || this.row?.verfDesc === "Documentos para Apelaciones"){

        this.columns = [
          { name: "Name", prop: "fullName" },
          { name: "Proof Type", prop: "verfDesc" },
          { name: "Verification For", prop: "proofRequired" }
        ];

        this.code = [];
        this.code.push({ value: 'APPR' });
      }else if(this.row?.verfCd !== 'AS') {
      this.code = this.selectData?.filter(
        (tableData) => tableData.code === this.row?.verfCd
      );
      } else {
        this.code = [];
        this.code.push({ value: 'ASPR' })
      }

      if (this.row?.verfDesc === "Appeal Facts Document" || this.row?.verfDesc === "Documentos de información para la apelación") {
        this.columns = [
          { name: "Name", prop: "fullName" },
          { name: "Proof Type", prop: "verfDesc" },
          { name: "Verification For", prop: "proofRequired" },
        ];
        this.code = [];
        this.code.push({ value: 'VFPR' });
      }

      if (this.row?.verfDesc === "Additional Information Form" || this.row?.verfDesc === "Formulario para Información Adicional") {
        this.columns = [
          { name: "Name", prop: "fullName" },
          { name: "Proof Type", prop: "verfDesc" },          
          { name: "Due Date", prop: "appealDueDate" },
        ];
        this.code = [];
        this.code.push({ value: 'MAPR' });
        if(this.row?.isMedicalAppealSw === 'Y'){
          this.isMedicalAppeal = true;
        }
        if (this.translatedLang === 'en') {
          this.vfdProofType = "Documents for Medical Appeals";
        } else {
          this.vfdProofType = "Documentos para apelaciones médicas de"
        }
      }

      if(this.translatedLang === 'sp'){
        this.columnData = [
          { name: "Nombre", prop: "fullName" },
          { name: "Tipo de comprobante", prop: "verfDesc" },
        ];
      }      
      if(this.rows[0] && this.rows[0]?.['proofRequired'] !== 'N/A'){
        this.verificationForFlag = true;
      }
      if(this.rows[0]){
    if (this.translatedLang !== 'en') {
      this.rows[0].proofRequiredValue = this.userProfileService.findSpTransalation(this.rows[0].proofRequired);
    } else {
      this.rows[0].proofRequiredValue = this.rows[0].proofRequired;
    }
    }

      if (this.row?.uploadAppealPetitionProof === true) {        
        this.uploadDocumentFlag = true
        const url = `publ/reference-tables/retrieve?table=PTPR`;
        this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
            this.options = [...(this.options || []), ...res['columnDetails']];
            // this.documents[0].docType = this.options[0]
            this.documents.forEach(e=> e.docType = this.options[0]);
            this.tableCode = [...(this.tableCode || []), res];
            const tableUploadData = {...this.row}
            tableUploadData.verfDesc = ""
            if (this.translatedLang === 'en') {
              tableUploadData.verfDesc = "Appeal Petition";
            } else {
              tableUploadData.verfDesc = "Petición de apelación"
            }
            this.vfdProofType = tableUploadData.verfDesc;
            this.rowsData = [tableUploadData]
        });       
      }
      else if(this.row?.uploadAppealProofVfd === true && this.row?.uploadAppealAiProof === false) {
        this.uploadDocumentFlag = true
        if (this.translatedLang === 'en') {
          this.vfdProofType = "Appeal Facts";
        } else {
          this.vfdProofType = "Información para la apelación"
        }
        let url = `publ/reference-tables/retrieve?table=VFPR`;
        this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
            this.options = [...(this.options || []), ...res['columnDetails']];
            this.tableCode = [...(this.tableCode || []), res]; 
            const tableUploadData = {...this.row}
            tableUploadData.verfDesc = ""
            if (this.translatedLang === 'en') {
              tableUploadData.verfDesc = "Appeal Facts Document";
            } else {
              tableUploadData.verfDesc = "Documentos de información para la apelación"
            }
            this.rowsData = [...this.rowsData, tableUploadData]
        });
         url = `publ/reference-tables/retrieve?table=APPR`;
        this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
            this.options = [...(this.options || []), ...res['columnDetails']];
            this.tableCode = [...(this.tableCode || []), res];
            const tableUploadData = {...this.row}
            tableUploadData.verfDesc = ""
            if (this.translatedLang === 'en') {
              tableUploadData.verfDesc = "Documents for Appeals";
            } else {
              tableUploadData.verfDesc = "Documentos para Apelaciones"
            }
            this.rowsData = [...this.rowsData, tableUploadData]
        });
      }
      else if (this.row?.uploadAppealAiProof === true && this.row?.uploadAppealProofVfd === false) {
        this.uploadDocumentFlag = true
        const url = `publ/reference-tables/retrieve?table=APPR`;
        this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
            this.options = [...(this.options || []), ...res['columnDetails']];
            // this.documents[0].docType = this.options[0]
            this.documents.forEach(e=> e.docType = this.options[0]);
            this.tableCode = [...(this.tableCode || []), res];
            const tableUploadData = {...this.row}
            tableUploadData.verfDesc = ""
            if (this.translatedLang === 'en') {
              tableUploadData.verfDesc = "Documents for Appeals";
            } else {
              tableUploadData.verfDesc = "Documentos para Apelaciones"
            }
            this.vfdProofType = tableUploadData.verfDesc;
            this.rowsData = [tableUploadData]
        });
       
      } 
      else if (this.code && this.code.length > 0 && this.code[0]?.value) {
        const url = `publ/reference-tables/retrieve?table=${this.code[0]?.value}`;
        this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId() })}).subscribe((res) => {
            this.options = [...res['columnDetails']];
            this.updateSelectedDocumentTypes();
            if(this.code[0]?.value === 'MAPR'){
              // this.documents[0].docType = this.options[0];
              this.documents.forEach(e=> e.docType = this.options[0]);
            }
        });
      }
   // } 
 }

 selectedOption(i) {
  this.documents[i].error = !this.documents[i].docType;
  if (this.documents[i].docType !== null) {
    this.setCZPRmessage(i);
  }
  this.addDocbuttonVisibility();
}

selectedOptionMobile(i) {
  let prevDocType;
  this.currentDocTypeObj = this.diffDocTypes[i]?.docType;
  let currentDocType = this.diffDocTypes[i].docType;
  this.currentDocType = this.translatedLang !== 'en' ? this.diffDocTypes[i]['docType']['spDescription'] : this.diffDocTypes[i]['docType']['enDescription']
  for (let j = 0; this.documents.length > j; j++) {
    if (this.documents[j].docType === null || this.documents[j]['file'] === null) {
      this.documents[j]['docType'] = this.diffDocTypes[i].docType
    } 
    if (this.documents[j]?.['file'] && this.diffDocTypes[i]?.['file'] && (this.documents[j]?.['file']?.['res'] === this.diffDocTypes[i]?.['file']?.['res'])) {
      prevDocType = this.documents[j].docType
      this.documents[j]['docType'] = this.diffDocTypes[i].docType
    }
    if(this.successDocUpload)  {
    const index = this.diffDocTypes.findIndex(k => k['file'] && this.documents[j]?.['file'] && (k['file']?.['res'] === this.documents[j]?.['file']?.['res']));
    if (this.diffDocTypes[i]['file'] === null && index >= 0 && this.diffDocTypes[index]?.docType?.code !== currentDocType?.code) {
      prevDocType = this.diffDocTypes[index]?.docType
      this.diffDocTypes[index].docType = currentDocType
      this.documents[j]['docType'] = currentDocType
    }
  }

  }
if(prevDocType) {
  for(let j = 0; this.documents.length > j; j++) {
    if(this.documents[j]['docType']['code'] === prevDocType?.code) {
      this.documents[j]['docType'] = currentDocType
    }
  }
  this.diffDocTypes.forEach(item => {
    if (item['commonItems'][0] === prevDocType?.code) {
      for (let k = 0; item['commonItems'].length > k; k++) {
        item['commonItems'][k] = currentDocType?.code
      }
    }
    if (item['docType'] === prevDocType) {
      item['docType'] = currentDocType
    }
  })
  if (this.successDocUpload && prevDocType === this.filteredDocs[0]['docType']) {
    this.documents = this.documents.filter(item => item['file'] !== null)
    this.diffDocTypes = this.diffDocTypes.filter(item => item['file'] !== null)
    this.filteredDocs.forEach(item => {
      item['docType'] = currentDocType
    })
  }
}
  this.documents[i].error = !this.documents[i]?.docType;
  if (this.documents[i]?.docType !== null) {
    this.setCZPRmessage(i);
  }
  this.changeType = false
  this.addDocbuttonVisibility();
}

  setCZPRmessage(i) {
    const vals = [...this.documents];
    const proofType = vals[i].docType?.code;
    if (vals.length === 1) {
      this.showCZPRmessage = ["BC", "UPP", "US", "CC"].includes(proofType);
    } else {
      this.showCZPRmessage = false;
    }
  }

  clickChangeType() {
    this.changeType = true;
    if(this.showClose) {
      this.closeMobile();
    }
  }

  addAnother() {
    if (this.isMedicalAppeal) {
      this.documents.push({
        docType: this.options[0],
        show: true,
        file: null,
        error: false,
        pageId: null, 
        groupId: null
      });
    } else if (this.ridpFlow) {
      this.documents.push({
        docType: this.documents[0].docType,
        show: true,
        file: null,
        error: false,
        pageId: this.ridpFlow? this.documents.length +1: null, 
        groupId: this.ridpFlow? 1: null
      });
    }  else {
      this.documents.push({
        docType: null,
        show: true,
        file: null,
        error: false,
        pageId: null, 
        groupId: null
      });
    }
    this.addDocbuttonVisibility();
  }

  addAnotherMobile() {
    if(this.successDocUpload) {
      if (this.isSupportingDocFlow) {
        this.addSupportingPage();
        this.currentSupportingDocIndex = this.supportingDocuments.length - 1;
        this.filteredDocs = this.supportingDocuments.filter(s => s.file !== null);
        if (this.filteredDocs?.length >= 25) {
          this.modalService.openMaxDocUploadLimit().subscribe;
          this.showClose = false;
        } else {
          this.showClose = true;
        }
      } else {
      let currentDocyType = this.filteredDocs[0]?.docType
      this.currentI = this.currentI + 1;
      this.documents.push({
        docType: currentDocyType,
        show: true,
        file: null,
        error: false,
        pageId: null, 
        groupId: null
      });
      this.diffDocTypes.push({
        docType: currentDocyType,
        show: true,
        file: null,
        error: false,
        commonItems: [],
        groupId: null
      });
      if (this.filteredDocs?.length >= 25) {
        this.modalService.openMaxDocUploadLimit().subscribe;
        this.showClose = false;
      } else {
        this.addDocbuttonVisibility();
        this.showClose = true
      }
      }
    } else {
      this.documents.push({
        docType: null,
        show: true,
        file: null,
        error: false,
        pageId: null, 
        groupId: null
      });
      this.diffDocTypes.push({
        docType: null,
        show: true,
        file: null,
        error: false,
        commonItems: [],
        groupId: null
      });

      this.addDocbuttonVisibility();
    }    
  }

  close(i: any) {
    this.documents.splice(i, 1);
    this.displayLoading = false;
    this.addDocbuttonVisibility();
  };

  closeMobile() {
    if (this.isSupportingDocFlow) {
      this.supportingDocuments = this.supportingDocuments.filter(item => item['file'] !== null);
      this.filteredDocs = this.supportingDocuments.filter(item => item['file'] !== null);
      this.updateSupportingDocError();
      this.showClose = false;
      return;
    }
    this.documents = this.documents.filter(item => item['file'] !== null)
    this.diffDocTypes = this.diffDocTypes.filter(item => item['file'] !== null)
    this.currentI = this.currentI - 1
    this.addDocbuttonVisibility();
    this.showClose = false
  };


  removeItem(i) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.documents[i].file = null;
        this.documents[i].show = true;
        this.addDocbuttonVisibility();
      }
    })
  };

  uniqueByKeepLast(data, key) {
    return [...new Map(
      data.map(x => [key(x), x])
    ).values()]
  }

  removeItemMobile(i) {
    let headers = new HttpHeaders({
      action: 'delete',
      'pageId': 'TCMUD',
      'sessionId' : this.token.getSessionId()
    })
    if(this.successDocUpload) {
      this.modalService.confirmDelete().subscribe((res) => {
        if (res) {
          const docId= this.filteredDocs[i]?.['file']?.['res']
          const removeUrl = `indi/neededDocuments/document/${docId}`;
          this.apiService.post(removeUrl, null,{headers: headers}).subscribe(() => {})
          const deleteDocumentDocType = this.filteredDocs[i]['docType']?.['code']
          this.documents.forEach(item => {
            if((item['docType']?.['code'] === this.filteredDocs[i]['docType']?.['code']) && (item['file']?.['res'] === this.filteredDocs[i]['file']?.['res'])) {
               item['file'] = null;
               item['show'] = true;
            }
          })
          this.diffDocTypes = this.diffDocTypes.filter((item, index, self) =>
            index === self.findIndex((t) => (
              t['docType']['code'] === item['docType']['code']
            ))
          )
          this.diffDocTypes.forEach(item => {
            if(item['docType']?.['code'] === this.filteredDocs[i]['docType']?.['code']) {
              //  item['file'] = null;
              //  item['show'] = true;
               item['commonItems'].pop()
            }
          })
          this.documents = this.documents.filter(item => item['file'] !== null)
          this.filteredDocs[i].file = null;
          this.filteredDocs[i].show = true;
          this.filteredDocs = this.filteredDocs.filter(item => item['docType']['spDescription'] === this.currentDocType || item['docType']['enDescription'] === this.currentDocType)
          this.filteredDocs = this.filteredDocs.filter(item => item['file'] !== null)
          this.successDocUpload = this.filteredDocs.length ? true: false;
          if(!this.filteredDocs.length) {
            this.diffDocTypes.forEach(item => {
              if(item['docType']?.['code'] === deleteDocumentDocType) {
                item['docType'] = null
                item['file'] = null;
                item['show'] = true;
                item['commonItems'].pop()
              }
            })
          } else {
            this.diffDocTypes.forEach(item => {
              if(item['docType']?.['code'] === deleteDocumentDocType) {
                 item['file'] = this.filteredDocs[0]['file'];
              }
            })
          }
          this.diffDocTypes = this.diffDocTypes.length > 1 ? this.diffDocTypes.filter(item => item['file'] !== null) : this.diffDocTypes;
          this.diffDocTypes = !this.diffDocTypes.length ? [{ docType: null, show: true, file: null, error: false, commonItems: [], groupId: null }] : this.diffDocTypes
          this.documents = !this.documents.length ? [{ docType: null, show: true, file: null, error: false, pageId: null, groupId: null }] : this.documents
          this.addDocbuttonVisibility();
          this.showClose = false
        }
      })
    } else {
      this.modalService.confirmDeleteMobile().subscribe((res) => {
        if (res ) {
          const removeDocumentGroup = this.diffDocTypes[i]['groupId']  
          this.documents.forEach((item) => {
            if(item['groupId'] === removeDocumentGroup) {
              const docId = item['file']?.['res']
              const removeUrl = `indi/neededDocuments/document/${docId}`;
              this.apiService.post(removeUrl, null,{headers: headers}).subscribe(() => {})
            }
          })
          this.documents = this.documents.filter(a => a['groupId'] !== removeDocumentGroup);
          this.filteredDocs = this.filteredDocs.filter(a => a['groupId'] !== removeDocumentGroup)
          this.diffDocTypes.splice(i, 1);
          this.diffDocTypes = !this.diffDocTypes.length ? [{ docType: null, show: true, file: null, error: false, commonItems: [], groupId: null }] : this.diffDocTypes
          this.documents = !this.documents.length ? [{ docType: null, show: true, file: null, error: false , pageId: null, groupId: null}] : this.documents
          this.addDocbuttonVisibility();
        }
      })
    }
  };

  trackByIdx(index: number): any {
    return index;
  }


  getFileDetails(fileData, i) {
    if (fileData.res !== null) {
      this.documents[i].show = false;
      this.documents[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      this.addDocbuttonVisibility();
      this.setCZPRmessage(i);
      //this.error = false;
    }
  }

  getFileDetailsMobile(fileData, i) {
    let currentGroupId;
    if (fileData.res !== null) {
      const index = this.diffDocTypes.findIndex(k => k['file'] === null && k['docType']?.['code'] === this.currentDocTypeObj?.['code'] );
      if(index >= 0) {
        i= index;
      }
      if(this.diffDocTypes[i]){
      this.diffDocTypes[i].show = false;
      this.diffDocTypes[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      }
      for(let j=0; this.documents.length > j; j++) {
        if(this.documents[j]?.['docType']?.['code'] === this.diffDocTypes[i]?.['docType']?.['code'] && this.documents[j].file === null){
          this.documents[j].show = false;
          this.documents[j].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };          
          if(this.successDocUpload === false) {
            if(j === 0 ) {
              this.documents[j].groupId =  1
              this.documents[j].pageId = 1
                currentGroupId = this.documents[j].groupId
            } else {
              this.documents[j].groupId = this.documents[j-1]?.groupId + 1
              this.documents[j].pageId =  1
              currentGroupId = this.documents[j].groupId
            }
            
          }
          if(this.successDocUpload === true) {
            this.documents[j].pageId = this.documents[j-1].pageId  + 1
            this.documents[j].groupId = this.documents[j-1].groupId           
            currentGroupId = this.documents[j].groupId
          }
          this.documents[j]['filePreview'] = this.documents[j]['file']['rawFile']['filePreview']
        }
      }
      this.addDocbuttonVisibility();
      this.setCZPRmessage(i);
      this.successDocUpload = true
      if (this.successDocUpload === true) {
        this.scrollToTop()
      }
      this.currentDocType = this.translatedLang !== 'en' ? this.diffDocTypes[i]?.['docType']?.['spDescription'] : this.diffDocTypes[i]?.['docType']?.['enDescription']
      this.currentI = i
      this.filteredDocs = this.documents.filter(item => item['groupId'] === currentGroupId &&  (item['docType']?.['spDescription'] === this.currentDocType || item['docType']?.['enDescription'] === this.currentDocType));
      this.showClose = false;
      this.diffDocTypes[i]['groupId'] = currentGroupId
    }
  }

  onEdit(i, doc){
    const groupId = doc['groupId']
    this.documents = this.documents.filter(item => item['file'] !== null)
    this.diffDocTypes = this.diffDocTypes.filter(item => item['file'] !== null)
    this.successDocUpload = true;
    if (this.successDocUpload === true) {
      this.scrollToTop()
    }
    this.currentDocType = this.translatedLang !== 'en' ? this.diffDocTypes[i]['docType']?.['spDescription'] : this.diffDocTypes[i]['docType']?.['enDescription'];
    this.currentDocCode =  this.diffDocTypes[i]['docType']['code']
    this.filteredDocs = this.documents.filter(item => item['groupId'] === groupId && (item['docType']?.['spDescription'] === this.currentDocType || item['docType']?.['enDescription'] === this.currentDocType))
    this.currentI = i;
    this.changeType = false;
    this.addDocbuttonVisibility();
  }

  onSupportingDocTypeMobileChanged(): void {
    const newDocType = this.supportingDocuments[0].docType;
    this.supportingDocuments.forEach(s => s.docType = newDocType);
    this.currentDocType = this.translatedLang !== 'en'
      ? newDocType?.spDescription
      : newDocType?.enDescription;
    this.updateSupportingDocError();
    this.filteredDocs = this.supportingDocuments.filter(s => s.file !== null);
    this.changeType = false;
  }

  onContinue() {
    this.successDocUpload = false;
    this.isSupportingDocFlow = false;
    this.scrollToCenter();
    this.filterIdenticalItems();
  }

  filterIdenticalItems() {
    this.diffDocTypes.forEach(item => {
      item['commonItems'] = []
        this.documents.forEach( data => {
          if (item['docType']?.['code'] === data['docType']?.['code']  && item['groupId'] === data['groupId']) {
          item['commonItems'].push(item['docType']['code']);
          item['show'] = data['show']
          item['file'] = data['file']

         }
        })
    })
    this.diffDocTypes = this.diffDocTypes.filter((item, index, self) =>
      index === self.findIndex((t) => (t['groupId'] === item['groupId'] && t['docType']['code'] === item['docType']['code'])))
  }

  addDocbuttonVisibility() {
    this.error = this.documents.some(doc => doc.file == null || !doc.docType);
  }

  scrollToTop() {
    setTimeout(() => {
        const container = document.querySelector('.mat-sidenav-content') as HTMLElement;
        if (container) {
            container.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        }
    }, 100)
  }

  scrollToCenter() {
    setTimeout(() => {
      const container = document.querySelector('.mat-sidenav-content') as HTMLElement;
      if (container) {
        const scrollHeight = container.scrollHeight;
        const clientHeight = container.clientHeight;
        const scroolLevel = (scrollHeight - clientHeight) / 2;
        container.scrollTo({ top: scroolLevel, left: 0, behavior: 'smooth' });
      }
    }, 100)
  }

  viewPdf(i, source) {
    const docId = source === 'mobileBrowser' ? this.filteredDocs[i].file.res.replace(/[{}]/g, "") : this.documents[i].file.res.replace(/[{}]/g, "");
    this.userProfileService.getPrintDoc(docId, 'TCMUD').subscribe((res: any) => {
      const file = new Blob([res], { type: 'application/pdf' });
      let newVariable: any;
      newVariable = window.navigator;
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(file);
      } else {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }

    });
  }

  showDocTypes(): void {
    this.modalService.openDocTypes();
  }

  submitDocuments(from) {
    this.userProfileService.fromMyAppeals.next(false);
    let submitUrl;
    if(from === 'desktop' && !this.ridpFlow) {
      submitUrl = `indi/neededDocuments/submitDocuments`;
    } else if (this.ridpFlow) {
       submitUrl = `indi/users/ridp/submitDocument`;
    } else {
      submitUrl = `indi/neededDocuments/mergeDocuments`;
    }
    const userType = sessionStorage.getItem("userType");
    const user = JSON.parse(sessionStorage.getItem("currentUser"));
    const mobileAppUser = JSON.parse(sessionStorage.getItem("isMobileUser"));
    this.userId = (userType && userType === "RP") || mobileAppUser ? sessionStorage.getItem("userName") : user.userId;

    let uploadData;
    // if (this.row?.refId) {
    //   const types = this.documents.map((doc) => {
    //     return {
    //       documentSubType: {
    //         code: doc.docType.code,
    //         value: doc.docType.enDescription,
    //       },
    //       documentId: doc.file.res,
    //       indvId: this.row?.clientId,
    //       documentType: { code: 'KB', value: 'KB Document'},
    //       groupId : doc.groupId,
    //       pageId : doc.pageId,
    //       fileName: doc.file.name,
    //       fileSize: doc.file.size,
    //       fileType: doc.file.type
    //     };
    //   });
    //   uploadData = {
    //     refId: this.row?.refId,
    //     caseNumber: this.row?.caseNum,
    //     userId: this.userId,
    //     typeOfDocument: [...types]
    //   };
    // } else {
      const types = this.documents.map((doc) => {
        let docType
        if(this.row?.uploadAppealProofVfd === true || this.row?.uploadAppealAiProof === true || this.row?.uploadAppealPetitionProof === true){
          const codeValue = this.tableCode.find(item =>(item.columnDetails.find(cd => (cd.code === doc.docType.code))))
          docType = {
            code: codeValue.tableId, value: codeValue.tableName
          }
        }
        else {
          docType = {
            code: this.code?.[0]?.value, value: this.row?.verfDesc
          }
        }
        return {
          documentType: this.ridpFlow ? {"code": "RIRI","value": "RIDP Related"} : docType,
          documentSubType: {
            code: doc.docType.code,
            value: doc.docType.enDescription,
          },
          documentId: doc.file.res,
          indvId: this.row?.clientId ? this.row?.clientId : this.row?.indvId,
          groupId : doc.groupId,
          pageId : doc.pageId,
          fileName: doc.file.name,
          fileSize: doc.file.size,
          fileType: doc.file.type,
          verificationFor: (!this.row?.proofRequired || this.row?.proofRequired === 'N/A') ? null : this.row?.proofRequired
        };
      });

      const supportingTypes = (this.ridpFlow && this.showSupportingDocUpload)
        ? this.supportingDocuments
            .filter(sdoc => sdoc.file && sdoc.docType)
            .map(sdoc => ({
              documentType: { code: 'RIRI', value: 'RIDP Related' },
              documentSubType: {
                code: sdoc.docType.code,
                value: sdoc.docType.enDescription,
              },
              documentId: sdoc.file.res,
              indvId: this.row?.clientId ? this.row?.clientId : this.row?.indvId,
              groupId: sdoc.groupId,
              pageId: sdoc.pageId,
              fileName: sdoc.file.name,
              fileSize: sdoc.file.size,
              fileType: sdoc.file.type,
              verificationFor: (!this.row?.proofRequired || this.row?.proofRequired === 'N/A') ? null : this.row?.proofRequired
            }))
        : [];

      if (this.row?.verfDesc === "Documents for Appeals" || this.row?.verfDesc === "Documentos para Apelaciones" 
          || this.row?.verfDesc === "Appeal Facts Documents, Documents for Appeals"
          || this.row?.verfDesc === "Documento de información para la apelación, Documentos para Apelaciones" 
          || this.row?.uploadAppealAiProof === true || this.row?.uploadAppealProofVfd === true
          || this.row?.verfDesc === "Appeal Facts Documents" || this.row?.verfDesc === "Documento de información para la apelación") {        
        uploadData = {
          appealNumber:this.row?.appealNum ? this.row?.appealNum : this.row?.appealNumber,
          caseNumber:  this.row?.caseNum  ? this.row?.caseNum : this.row?.caseNumber,
          userId: this.userId,
          typeOfDocument: [...types, ...supportingTypes],
        };
      }else if (this.row?.verfDesc === "Additional Information Form" || this.row?.verfDesc === "Formulario para Información Adicional") {        
      uploadData = {
        appealNumber:this.row?.issueId ? this.row?.issueId : this.row?.issueId,
        caseNumber:  this.row?.caseNum  ? this.row?.caseNum : this.row?.caseNumber,
        userId: this.userId,
        typeOfDocument: [...types, ...supportingTypes],
      };
    }else{
        uploadData = {
          caseNumber: this.row?.caseNum,
          userId: this.userId,
          typeOfDocument: [...types, ...supportingTypes],
        }
      };
    //}
    if (this.partnerOrgDocSwitch) {
      const entityId = sessionStorage.getItem('mtlToken');
      if (entityId) {
        uploadData.entityId = entityId;
      }
    }
   
    const contentHeader = new HttpHeaders({'pageId':'TCMUD', 'sessionId' : this.token.getSessionId()})
    this.apiService.post(submitUrl, uploadData, {headers: contentHeader}).subscribe(() => {
      this.docUploadSuccess.emit({ success: true });
      if(this.ridpFlow) {
        sessionStorage.setItem('ridpReviewDocs', 'true')
        this.router.navigateByUrl("/verify-identity/uploadDocuments");
      }
    });
  }

  getFileProgress(event) {
    if (event) {
      this.displayLoading = event.displayLoading;
      this.docName = event.fileName;
      this.displayUpload = this.displayLoading ? false : true
    } else {
      this.displayLoading = false;
      this.docName = null;
      this.displayUpload = this.displayLoading ? false : true
    }
  }

  getSupportingFileProgress(event) {
    if (event) {
      this.supportingDisplayLoading = event.displayLoading;
      this.supportingDocName = event.fileName;
    } else {
      this.supportingDisplayLoading = false;
      this.supportingDocName = null;
    }
  }
// Update selected document types when language changes
  updateSelectedDocumentTypes() {
    if (!this.options?.length) {
      return;
    }
    const optionsMap = new Map(this.options.map(opt => [opt.code, opt]));
    const updateDocType = (doc: any) => {
      if (doc?.docType?.code) {
        const matchingOption = optionsMap.get(doc.docType.code);
        if (matchingOption) {
          doc.docType = matchingOption;
        }
      }
    };
    this.documents.forEach(updateDocType);
    this.diffDocTypes.forEach(updateDocType);
    this.filteredDocs.forEach(updateDocType);
    if (this.currentDocTypeObj?.code) {
      const matchingOption = optionsMap.get(this.currentDocTypeObj.code);
      if (matchingOption) {
        this.currentDocTypeObj = matchingOption;
      }
    }
  }

  lesswidthFontSize(){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return (globalLang === 'fa' || globalLang === 'fr' || globalLang === 'vi') && !this.ridpFlow;
  }

  extrawidthFontSize(){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return (globalLang === 'tl' || globalLang === 'de') && !this.ridpFlow;
  }

  ridpButtonTranslate(ridpFlow: boolean){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    if(ridpFlow){
      return globalLang === 'tl' || globalLang === 'de' || globalLang === 'ru' || globalLang === 'fr' || globalLang === 'vi'; 
    }
    return false;
  }

  getRidpFontSize(): string | null {
    const globalLang = sessionStorage.getItem('globalTranslatedLan');
    if (globalLang === 'de' || globalLang === 'tl' || globalLang === 'ru' || globalLang === 'fr' || globalLang === 'vi') {
      return '12px !important';
    }else if (this.translatedLang === 'sp') {
      return '10px !important';
    }else{
      return '15px !important';
    }
  }

  isGlobalTranslated(): boolean {
    const globalLang = sessionStorage.getItem('globalTranslatedLan');
    return !!globalLang && globalLang !== 'en' && globalLang !== 'undefined';
  }
}